const a = (t) => t && typeof t == "object" && "variants" in t ? t.variants : void 0, i = (t, e) => (t.find((n) => n.width >= e) || t[t.length - 1]).src;
export {
  a as getImageVariants,
  i as selectImageVariant
};
//# sourceMappingURL=responsiveImage.js.map
